const theme = {
  fontFamily: "montserrat",
  colors: {
    mainBgColor: "#002361",
    mainDark: "#00184a",
  },
  sliderTitle: {
    color: "#e5e5e5",
    fontSize: "24px",
    fontWeight: "700",
  },
  image: {
    aspectRatio: "4 / 3",
    borderRadius: "10px",
  },
  sliderItemLabel: {
    color: "#fff",
    fontWeight: 600,
  },
  moreBtn: {
    borderRadius: "18px",
    boxSizing: "border-box",
    padding: "8px 30px 8px 30px",
    border: "1px solid white",
    color: "#fff",
    fontWeight: "500",
    fontSize: "14px",
    outline: "none",
    cursor: "pointer",
    textDecoration: "none",
  },
  moreBtnHover: {
    color: "#00ae42",
  },
  sliderHeader: {
    margin: "20px 65px",
  },
  sliderHeaderSmall: {
    margin: "20 35px",
  },
  sliderHeaderMobile: {
    margin: "20px 45px",
  },
  playBtnHighlights: {
    color: "#00ae42",
  },
  slideBtn: {
    backgroundColor: "rgba(0, 0, 0, 0.7)", // always use rgba with opacity 0.7 here
    color: "#fff",
  },
};

export default theme;
